var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 10H30.185M10.9167 1.75H29.25C34.3126 1.75 38.4167 5.85406 38.4167 10.9167V29.25C38.4167 34.3126 34.3126 38.4167 29.25 38.4167H10.9167C5.85406 38.4167 1.75 34.3126 1.75 29.25V10.9167C1.75 5.85406 5.85406 1.75 10.9167 1.75ZM27.4167 18.9283C27.6429 20.4541 27.3823 22.0124 26.6719 23.3815C25.9615 24.7507 24.8374 25.8609 23.4596 26.5544C22.0819 27.2479 20.5205 27.4893 18.9976 27.2442C17.4747 26.9992 16.0679 26.2802 14.9772 25.1895C13.8865 24.0988 13.1675 22.6919 12.9225 21.1691C12.6774 19.6462 12.9188 18.0848 13.6123 16.707C14.3057 15.3292 15.416 14.2052 16.7851 13.4948C18.1543 12.7844 19.7125 12.5237 21.2383 12.75C22.7947 12.9808 24.2356 13.706 25.3481 14.8186C26.4606 15.9311 27.1859 17.372 27.4167 18.9283Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7b2c22cf2e9c59ac8023e34a9e1462ee.svg";
export { ForwardRef as ReactComponent };